import { FunctionComponent } from 'react'
import styles from './KPIMobileDialog.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import PlanningKPI from '../../KPI/planningKPI'
import { PlanningTabsState } from '@/hooks/usePlanningRights.ts'
import { PlanningKPIData } from '../../hooks/usePlanningKPI.ts'

interface KPIMobileDialogProps {
    open: boolean
    handleClose: () => void
    planningTabs: PlanningTabsState
    isParent: boolean
    kpi: PlanningKPIData
    merger: boolean
    filterEvents: (filters: string[]) => void
}

const KPIMobileDialog: FunctionComponent<KPIMobileDialogProps> = ({
    open,
    handleClose,
    planningTabs,
    isParent,
    kpi,
    merger,
    filterEvents
}: KPIMobileDialogProps) => {
    const { t } = useTranslation()

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('myIndicators')} parent={isParent} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.Container}>
                    <PlanningKPI
                        isParent={isParent}
                        planningTabs={planningTabs}
                        kpi={kpi}
                        mobileView={true}
                        merger={merger}
                        filterEvents={filterEvents}
                    />
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleClose} parent={isParent} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default KPIMobileDialog
